import { render, staticRenderFns } from "./newakuntansi.vue?vue&type=template&id=68253802&scoped=true"
import script from "./newakuntansi.vue?vue&type=script&lang=js"
export * from "./newakuntansi.vue?vue&type=script&lang=js"
import style0 from "./newakuntansi.vue?vue&type=style&index=0&id=68253802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68253802",
  null
  
)

export default component.exports